import React from 'react';

import CommonStrings from 'resources/common-strings';

export default class SubjectTabHelpText extends React.Component {
    render() {
        const colorKeyImg = require('../../../../resources/images/colorkey.png');

        return (
            <div>
                <p>{CommonStrings.tabHelp.tabColorText}</p>
                <img src={colorKeyImg}></img>
                <p>
                    {CommonStrings.tabHelp.percentageText}
                    <a key="help-link" href={CommonStrings.tabHelp.helpLink} target="_blank">
                        {CommonStrings.tabHelp.helpLinkText}
                    </a>
                    .
                </p>
                <p>{CommonStrings.tabHelp.priorTermText}</p>
            </div>
        );
    }
}
